import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Divider, Modal, Button, Space } from 'antd';
import { guide as userGuide, USER_GUIDE_KEY } from '@/apis/user/guide';
import { useConfig } from '@/apis/ducc';
import JsLoading from '@/components/js-loading';
import queryGeneralDataScopeByErp from '@/apis/generic/skuPoolService/queryGeneralDataScopeByErp';

export default React.forwardRef(function NewGuide(props, ref: React.Ref<{ show(): void }>) {
  const [visiable, setVisiable] = useState(false);
  const [getConfig] = useConfig();

  const guideVideo = getConfig(['productDataPanel', 'guideVideo']);

  useEffect(() => {
    // 只有销售erp才能展示销售ERP
    queryGeneralDataScopeByErp()
      .then((res) => {
        const { ret, data } = res;

        if (ret === '0') return !!data.userType?.find((item: any) => item.ord === '4');
      })
      .then((hasPrimission) => {
        if (!hasPrimission) return;
        // 再判断是否需要弹窗
        userGuide({ key: USER_GUIDE_KEY.goodsMonitoring.key }).then((res = {}) => {
          const { ret } = res;

          if (ret === '0') setVisiable(true);
        });
      });
  }, []);

  useImperativeHandle<{ show(): void }, { show(): void }>(ref, () => {
    return {
      show() {
        setVisiable(true);
      },
    };
  });

  return (
    <Modal
      width="660px"
      visible={visiable}
      title={<span style={{ fontWeight: 'bold' }}>新手帮助</span>}
      destroyOnClose
      onCancel={() => setVisiable(false)}
      footer={
        <div style={{ textAlign: 'center' }}>
          <Button onClick={() => setVisiable(false)} type="primary">
            我知道了
          </Button>
        </div>
      }
    >
      <div
        style={{
          marginTop: '-20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '17px',
        }}
      >
        <div
          style={{
            marginRight: '17px',
            width: '62px',
            height: '62px',
            paddingTop: '6px',
            borderRadius: '31px',
            overflow: 'hidden',
            background:
              'linear-gradient(322.31deg, rgba(243, 252, 255, 0.7) -0.23%, rgba(246, 252, 255, 0.7) 34.01%, rgba(255, 255, 255, 0.7) 36.28%, rgba(255, 255, 255, 0) 82.35%), linear-gradient(325.24deg, #0038FF -3.06%, #5670FA 60.51%, #B858FF 115.98%)',
          }}
        >
          <img
            width="68"
            src="//img30.360buyimg.com/pop/jfs/t1/126735/8/34943/1085018/641409e1Fb7c4ddba/9e410806cf77a22e.gif"
          />
        </div>
        <div>
          <div
            style={{
              fontSize: '20px',
              lineHeight: '30px',
            }}
          >
            欢迎使用商品监控，帮助您高效管理商品销售任务
          </div>
          <Space
            split={<Divider type="vertical" />}
            size={14}
            style={{
              color: 'rgba(0, 0, 0, 0.65)',
              fontSize: '14px',
            }}
          >
            <span>设置和管理销售计划</span>
            <span>自定义创建商品分组</span>
            <span>一站式查数看数</span>
          </Space>
        </div>
      </div>
      {!!guideVideo ? (
        <video style={{ width: '100%', height: '400px', marginBottom: '-18px' }} controls src={guideVideo} />
      ) : (
        <JsLoading />
      )}
    </Modal>
  );
});
